import { render, staticRenderFns } from "./organize-manage.vue?vue&type=template&id=b5bf9e14&"
import script from "./organize-manage.vue?vue&type=script&lang=js&"
export * from "./organize-manage.vue?vue&type=script&lang=js&"
import style0 from "./organize-manage.vue?vue&type=style&index=0&id=b5bf9e14&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports